/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const orderApprovalDetails = {
  back: 'Voltar à lista',
  showForm_APPROVE: 'Aprovar pedido...',
  showForm_REJECT: 'Rejeitar pedido...',
  form: {
    title_APPROVE: 'Aprovar pedido... orderCode}} para um total de {{{orderTotal}}',
    title_REJECT: 'Rejeitar Ordem... orderCode}} para um total de {{{orderTotal}}',
    submit_APPROVE: 'Aprovar',
    submit_REJECT: 'Rejeitar',
    cancel: 'Cancelar',
    comment_APPROVE: {
      label: 'Comentário (opcional, máximo de 255 caracteres)',
      placeholder: '',
    },
    comment_REJECT: {
      label: 'Comentário (máximo de 255 caracteres)',
      placeholder: '',
    },
  },
  permissionResults: {
    header: 'Detalhes de aprovação do cliente',
    permission: 'Permissão',
    approver: 'Aprovarr',
    status: 'Estado',
    approverComments: 'Comentários de Aprovaror',
    noApprovalComments: 'Nenhum',
    permissionType_B2BBudgetExceededPermissão:
      'O orçamento associado ao centro de custo escolhido foi excedido',
    permissionType_B2BOrderThresholdPermissão:
      'O total do pedido excedeu o limite por pedido',
    permissionType_B2BOrderThresholdTimespanPermissão:
      'O total de pedidos excedeu o limite por intervalo de tempo',
  },
};

export const orderApprovalList = {
  orderCode: 'Ordem #',
  POCode: 'DEPOIS #',
  placedBy: 'Colocado por',
  date: 'Data',
  status: 'Estado',
  total: 'Total',
  none: 'Nenhum',
  emptyList: 'Não há ordens para aprovar no momento.',
  orderApprovalList: 'Lista de aprovação de pedidos',
};

export const orderApprovalGlobal = {
  notification: {
    noSufficientPermissãos: 'Não há permissões suficientes para acessar esta página.',
  },
};

export const orderApproval = {
  orderApprovalDetails,
  orderApprovalList,
  orderApprovalGlobal,
};
